import {
  Component,
  Input,
  OnInit,
  ChangeDetectionStrategy,
} from '@angular/core';
import { ThemisRoute } from '../edumono-route';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { environment } from 'src/environments/environment';
import { OrganizationService } from '../../shared/organization.service';

@Component({
  selector: 'app-navbar-item',
  templateUrl: './navbar-item.component.html',
  styleUrls: ['./navbar-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class NavbarItemComponent implements OnInit {
  @Input() route: ThemisRoute;
  @Input() collapsed: boolean = false;
  @Input() active: boolean = false;

  constructor(
    private iconRegistry: MatIconRegistry,
    private sanitizer: DomSanitizer,
    private organizationService: OrganizationService,
  ) {}

  ngOnInit(): void {
    this.iconRegistry.addSvgIcon(
      this.route.name,
      this.sanitizer.bypassSecurityTrustResourceUrl(this.route.image),
    );
  }

  goToPage(): void {
    const base =
      environment.translator_url ?? `https://translator${environment.domain}`;
    const organizationId = this.organizationService.getOrganizationId();
    const path = `${base}${this.route.route}`;
    const url = organizationId
      ? `${path}?org=${encodeURIComponent(organizationId)}`
      : path;
    window.open(url, '_blank');
  }
}
